import { combineReducers } from "redux";
import common from "./common";
import menus from "../../containers/Sidebar/state/reducer";
import productsGroup from "../../containers/ProductGroup/state/reducer";
import products from "../../containers/Products/state/reducer";
import combos from "../../containers/Combos/state/reducer";
import approvals from "../../containers/FileApprovals/state/reducer";
import keyPos from "../../containers/KeyPos/state/reducer";
import posDecentralized from "../../containers/PosDecentralized/state/reducer";
import posSurvey from "../../containers/Survey/state/reducer";
import geoTree from "../../containers/GeoTree/state/reducer";
import ezds from "../../containers/Ezd/state/reducer";
import selloutApprovals from "../../containers/Sellout/FileApprovals/state/reducer";
import validationRules from "../../containers/ValidationRules/state/reducer";
import selloutFileUpload from "../../containers/Sellout/FileSubmission/state/reducer";

const reducers = {
  common,
  menus,
  productsGroup,
  products,
  combos,
  approvals,
  keyPos,
  posDecentralized,
  posSurvey,
  geoTree,
  ezds,
  selloutApprovals,
  validationRules,
  selloutFileUpload,
};

const combinedReducers = Object.keys(reducers).length
  ? { ...reducers }
  : {
      default: (state) => (state == null ? (state = []) : state),
    };

export default combineReducers(combinedReducers);
